import { Button, Typography, useTheme } from "@mui/material";
import { CustomTheme } from "helpers/Theme";

type DayItemsProps = {
  label: string;
  active?: boolean;
  onClick?: () => void;
};

export const DayItems = ({ label, active, onClick }: DayItemsProps) => {
  const { palette } = useTheme<CustomTheme>();
  return (
    <Button
      sx={{
        minWidth: 132,
        height: 40,
        borderRadius: 20,
        backgroundColor: active ? palette.primary.main : "transparent",
        "&:hover": { backgroundColor: palette.primary.main }
      }}
      onClick={onClick}>
      <Typography
        color={active ? "common.white" : "common.black"}
        fontWeight={active ? "700" : "400"}
        fontSize={16}>
        {label}
      </Typography>
    </Button>
  );
};
